<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import { Pencil } from "lucide-svelte";
  import { Plus } from "lucide-svelte";
  import { onDestroy } from "svelte";
  import { fly } from "svelte/transition";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { PackagePlus } from "lucide-svelte";
  import { Percent } from "lucide-svelte";
  import { useRequestDraft } from "../hooks/useRequestDraft";
  import { EditStatus } from "$src/domain/core/EditStatus";
  import { Loader } from "lucide-svelte";
  import TakeoverRequestDialog from "./drafts/takeover-request-dialog.svelte";
  import DraftInprogressDrawer from "./drafts/draft-inprogress-drawer.svelte";
  import AddProjectProductDialog from "$src/presentation/products/components/add-project-product-dialog.svelte";

  export let groupStoreId: number;
  export let projectId: number;

  let isPlusOpen = false;

  const requestDraftCommand = useRequestDraft();

  const unsubscribe = isEditActive.subscribe((value) => {
    if (!value) {
      isPlusOpen = false;
    }
  });

  function togglePlusMenu() {
    isPlusOpen = !isPlusOpen;
    angle.set(isPlusOpen ? 45 : 0);
  }

  function requestDraft() {
    $requestDraftCommand.mutate({ groupStoreId, projectId });
  }

  const angle = tweened(0, {
    duration: 100,
    easing: cubicOut,
  });

  onDestroy(() => {
    unsubscribe();
  });
</script>

{#if $requestDraftCommand.isSuccess}
  {#if $requestDraftCommand.data?.status == EditStatus.InProgress}
    <DraftInprogressDrawer {projectId} {groupStoreId} draftPermission={$requestDraftCommand.data} />
  {/if}
{/if}

<TakeoverRequestDialog />

{#if $isEditActive === false}
  <div
    class="fixed bottom-24 md:bottom-16 right-5 z-50"
    transition:fly={{ x: 100, duration: 300 }}
  >
    <Button
      size="action"
      on:click={() => requestDraft()}
      class="  rounded-full p-4  transition-transform transform  hover:scale-110"
    >
      {#if $requestDraftCommand.isLoading}
        <Loader size="32" class="animate-spin" />
      {:else}
        <Pencil size="32" />
      {/if}
    </Button>
  </div>
{:else}
  <div
    class="fixed bottom-24 md:bottom-16 right-5 z-50 flex flex-col items-end space-y-3"
    transition:fly={{ x: 100, duration: 300 }}
  >
    {#if isPlusOpen}
      <div
        transition:fly={{ y: 100, duration: 300 }}
        class="flex flex-row gap-4 items-center pr-2"
      >
        <div
          class=" bg-primary/80 text-primary-foreground p-2 rounded-lg text-sm"
        >
          Remise de prix
        </div>
        <Button
          variant="default"
          class="w-12 h-12 rounded-full p-1  transition-transform transform  hover:scale-110"
        >
          <Percent />
        </Button>
      </div>
      <div
        transition:fly={{ y: 100, duration: 300 }}
        class="flex flex-row gap-4 items-center pr-2"
      >
        <div
          class=" bg-primary/80 text-primary-foreground p-2 rounded-lg text-sm"
        >
          Ajout d'articles
        </div>
        <AddProjectProductDialog />
        <!-- <Button
          variant="default"
          class="w-12 h-12 rounded-full p-1  transition-transform transform  hover:scale-110"
        >
          <PackagePlus />
        </Button> -->
      </div>
    {/if}
    <Button
      variant="default"
      size="action"
      on:click={togglePlusMenu}
      style={isPlusOpen ? `transform: rotate(${$angle}deg)` : ""}
      class="hover:bg-primary rounded-full p-4  transition-transform transform  hover:scale-110"
    >
      <Plus size="32" />
    </Button>
  </div>
{/if}
